export enum LogLevel {
    Error = 'Error',
    Warning = 'Warning',
    Information = 'Information'
}